import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-team-invoice-details-dialog',
  templateUrl: './team-invoice-details-dialog.component.html',
  styleUrls: ['./team-invoice-details-dialog.component.scss']
})
export class TeamInvoiceDetailsDialogComponent implements OnInit {
  @Input() display: boolean;
  @Output() displayChange = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  onClose() {
    this.displayChange.emit(false);
  }

  // Work against memory leak if component is destroyed
  ngOnDestroy() {
    // this.displayChange.unsubscribe();
  }
}
